"use strict";
/**
 * @module Modal
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Action;

(function (Action) {
  Action["OPEN"] = "OPEN";
  Action["CLOSE"] = "CLOSE";
  Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));

var ActionType;

(function (ActionType) {
  ActionType["OPEN"] = "APP::MODAL::OPEN";
  ActionType["CLOSE"] = "APP::MODAL::CLOSE";
  ActionType["UPDATE"] = "APP::MODAL::UPDATE";
  ActionType["FOOTER_BUTTON_CLICK"] = "APP::MODAL::FOOTER::BUTTON::CLICK";
  ActionType["FOOTER_BUTTON_UPDATE"] = "APP::MODAL::FOOTER::BUTTON::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));

var Size;

(function (Size) {
  Size["Small"] = "small";
  Size["Medium"] = "medium";
  Size["Large"] = "large";
  Size["Full"] = "full";
})(Size = exports.Size || (exports.Size = {}));